<template>
  <div class="library__nav">
    <ul id="tabs" class="nav h-center-align">
      <NavTab v-for="(section, index) in sectionsList" :key="`section-${index}`" :active-section="activeSection" :section-name="section.label" :section-key="section.value"></NavTab>
    </ul>
    <StoreConnectedSelect class="library__mobile-dropdown" store="library" name="activeSection" :options="sectionsList" close-on-select></StoreConnectedSelect>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import NavTab from './NavTab.vue';
  import StoreConnectedSelect from '../form-items/StoreConnectedSelect.vue';

  export default {
    name: 'Navigation',
    components: {
      NavTab,
      StoreConnectedSelect,
    },
    data() {
      return {
        sectionsList: [
          { label: 'Member Documents', value: 'member_documents' },
        ],
      };
    },
    computed: {
      ...mapGetters('library', ['activeSection']),
    },
  };
</script>

